<template>
    <div>
        <div class="position">
            <span>您现在的位置：<a href="/">首页</a>   >   西安12345政务服务便民热线  >  12345热线</span>
            <div>
                <span>
                    <a href="/">首页</a>
                    <span>/</span>
                </span>
                <span>
                    <a>互动</a>
                </span>
            </div>
        </div>
        <div class="container">
            <div class="left">
                <div v-for="(item, index) in list" :key="index" class="box">
                    <div class="boxLeft" >
                        <img :src="require('@/assets/images/channel/' + index + '.png')"/>
                        <!-- <p :class="index==3?'_top':'_center'">{{ item.name }}</p> -->
                        <p class="_center">{{ item.name }}</p>
                    </div>
                    <div :class="index==3||index==4||index==5?'haveRight':'boxCenter'">
                        <p v-if="index==0" class="tel">029-12345</p>
                        <!-- <p v-if="index==2" class="e">请如实填写诉求信息，发送到邮箱12345@xa.gov.cn即可。 </p> -->
                        <p class="t">{{ item.t }}</p>
                    </div>
                    <div class="boxRight" v-if="index==3">
                        <img src='@/assets/images/channel/wechat.png'/>
                    </div>
                    <!-- <div class="boxRight" v-if="index==4">
                        <img src='@/assets/images/channel/weibo.png'/>
                    </div> -->
                    <div class="boxRight" v-if="index==4">
                        <img src='@/assets/images/channel/app.png'/>
                    </div>
                </div>
            </div>
            <div class="right">
                <hotline/>
            </div>
        </div>
    </div>
</template>

<script>
import  hotline  from "@/components/hotline";
import "@/assets/styles/loc.css"
export default {
    data() {
        return {
            list: [
                { name: "电话",t:"拨打电话接通后反映问题即可。" },
                { name: "网络",t:'访问西安市人民政府网“互动”栏目，点击“我要诉求”按页面提示进行注册，再填写信息反映问题即可。'},
                // { name: "邮箱",t:"姓名、性别、联系电话、邮箱、身份证号、是否愿意公开、诉求类型、联系地址、诉求标题、诉求内容 " },
                { name: "市长信箱",t:"访问西安市人民政府网“互动”栏目，点击“市长信箱”按页面提示进行注册，再填写信息反映问题即可。 " },
                { name: "微信",t:"扫描二维码或者添加微信公众号“西安12345”关注，选择“自助下单”按提示填写信息反映问题即可。" }
                // { name: "微博",t:"扫二维码或者添加名称“西安12345市民热线”关注，了解12345平台的最新动态。（微博渠道仅作为信息发布，不受理诉求，如您有具体诉求请通过其他渠道提交）。 " },
                // { name: "App",t:" 扫二维码下载12345市民热线APP。 注册后按提示填写信息反映问题即可。" },
                // { name: "传真",t:"下载表格，如实完整填写诉求信息后传真至【029-12345转8号键】即可。" },
            ],
        };
    },
    components:{
        hotline
    },
    created(){
    //     this.getUserInfo(res=>{
    //      console.log("channel:",res)
    //    })
    }
};
</script>
<style scoped>
@media screen and (max-width: 1200px){
      body .haveRight{
        position: static;
    }

    body .boxRight{
        position: static;
        margin-left: 10px;
    }
}
@media screen and (max-width: 1150px){
    .container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0px;
        padding: 0px;
    }

    body .left{
        width: 95%;
        margin-right:0px;
         padding:0px;
        order: 2;
        display: flex;
        justify-content: center;

    }
    body .right{
        width: 95%;
        order: 1;
        margin-bottom: 15px;
    }
    body .boxCenter {
        display: inline;
        margin-left: 0px;
        padding:0px 10px 20px 40px;
        /* padding: 52px 36px; */
    }
    body .haveRight{
        position: static;
    }

    body .boxRight{
        position: static;
        margin-left: 10px;
    }
    body .box{}

}
 /* lang="scss" */
.container {
    display: flex;
    justify-content: space-between;
}
.left {
    width: 75%;
    /* height: 723px; */
    background: #ffffff;
    flex-flow: row wrap;
    display: flex;
    /* 左右 */
    /* justify-content: space-around; */
    justify-content: space-between;
    /* 上下 */
    align-content: space-between;
    padding: 52px 36px;
    margin-right: 20px;
}
.box {
    width: 450px;
    min-height: 130px;
    background: #ffffff;
    border: 1px solid #dadada;
    box-shadow: 0px 1px 8px 0px #b7b6b6;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 20px;
    display: flex;
}
.boxLeft {
    height: 100%;
    border-right: 1px dashed #dadada;
    /* float: left; */
    padding-right: 10px;
    text-align: center;
}
.boxLeft img {
}
.boxLeft p {
    /* word-wrap: break-word; */
    width: 26px;
    height: 32px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #226ebc;
    line-height: 16px;
}
.boxCenter {
    display: inline-block;
    width: 87%;
    margin-left: 16px;
}
.haveRight{
    display: inline-block;
    width: 52%;
    margin-left: 16px;
}
.boxCenter,.haveRight{
    position: relative;
    /* top: 10%; */
}
.boxRight{
    display: inline-block;
    vertical-align: top;
}
.boxRight img{
}
.t{
    margin: 0;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
}
.tel{
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #22A1BC;
    line-height: 36px;
    margin: 0;
}
.e{
    word-wrap: break-word;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
}
._top{
    margin-top: -5px !important;
}
._center{
    padding: 15px 0;
}
.right {
    width: 25%;
}
</style>
